import siFetch from "api/fetch";

const signOut = (init = null) => siFetch("/api/v1/users/logout", init);

export default signOut;
